import { Injectable } from '@angular/core';

import { CommonService } from '@modweb5/sharedServices/commonService/common.service';

import { NavigateService } from '@modweb5/sharedServices/navigateService/navigate.service';
import {environment} from '@modweb5/environments/frontends/environment';
import { ObservableService } from '@modweb5/sharedServices/observableService/observable-service.service';
import { TUser } from '@modweb5/interfaces/authentication.interface';
import { TAccessRights } from '@modweb5/interfaces/modules.interface';

@Injectable({
	providedIn: 'root'
})
export class UserService {

	user: TUser | null = null;

	constructor(
		private commonService: CommonService,
		private _navigateService: NavigateService,
		private observableService: ObservableService
	) {
		this.user = { isLogin: false };
	}

	setUser(aUser: TUser): void {
		this.user.isLogin = aUser.isLogin;
		this.setOtherUserValues(aUser)
		this.observableService.emitUserInfo(this.user);
		if (!this.user.isLogin) {
			this._navigateService.navigate('login', '');
		}
	}


	private setOtherUserValues(aUser: TUser): void {
	 // Když hodnota nepřijde ze serveru, tak nepřepíše stávající nastavenou hodnotu.
	 // Výjimka je this.user.isLogin, us1, us2 a lcnt
		if (typeof aUser.id !== typeof undefined) {
			this.user.id = aUser.id;
		}
		if (typeof aUser.hierarchy !== typeof undefined) {
			this.user.hierarchy = aUser.hierarchy;
		}
		if (typeof aUser.moduleAccess !== typeof undefined) {
			this.user.moduleAccess = aUser.moduleAccess;
		}
		if (typeof aUser.name !== typeof undefined) {
			this.user.name = aUser.name;
		}
		if (typeof aUser.surname !== typeof undefined) {
			this.user.surname = aUser.surname;
		}
		if (typeof aUser.company !== typeof undefined) {
			this.user.company = aUser.company;
		}
		if (typeof aUser.workerId !== typeof undefined) {
			this.user.workerId = aUser.workerId;
		}
		if (typeof aUser.us1 !== typeof undefined) {
			this.user.us1 = aUser.us1;
		}
		if (typeof aUser.us2 !== typeof undefined) {
			this.user.us2 = aUser.us2;
		}
		if (typeof aUser.lcnt !== typeof undefined) {
			this.user.lcnt = aUser.lcnt;
		} else {
			this.user.lcnt = '';
		}
	}

	getUser(): null |TUser {
		return this.user;
	}

	getUserHash(): string {
		if (!this.user.isLogin) {
			this.user.us1 = this.commonService.getCookie(`${environment.cookiePrefix}_us1`);
		}
		return this.user.us1;
	}

	getPCHash(): null | string {
		let resultFcn = null;
		if (environment.pcHashName !== '') {
			resultFcn = this.commonService.getCookie(environment.pcHashName);
		}
		return resultFcn 
	}

	getUserLCNT(): string {
		if (!this.user.isLogin) {
			const lcnt = this.commonService.getCookie(`${environment.cookiePrefix}_lcnt`);
			if (lcnt !== null) {
				this.user.lcnt = lcnt;
			} else {
				this.user.lcnt = '';
			}
		} 
		return this.user.lcnt;
	}

	getWorkerId(): null | number {
		let resultFcn = null;
		if (this.user.isLogin) {
			resultFcn = this.user.workerId;
		}
		return resultFcn;
	}

	getLoginHash(): string {
		if (!this.user.isLogin) {
			this.user.us2 = this.commonService.getCookie(`${environment.cookiePrefix}_us2`);
		}
		return this.user.us2;
	}


}
